<template>
  <div class="container-fluid navigation-bar p-1 px-2">
<!--    <div class="at-banner" >-->
<!--      <div class="at-banner__content">-->
<!--        <div class="at-banner__text">Turn on notifications on this device?</div>-->
<!--        <a class="at-banner__button">TURN ON</a>-->
<!--      </div>-->
<!--      <div class="at-banner__close" ></div>-->
<!--    </div>-->

    <button @click="toggle" class="burger">
      <font-awesome-icon icon="fa-solid fa-bars"/>
    </button>
    <div class="navbar-logo"></div>

    <!-- YouTube-style Notification System -->
    <div class="notification-container">
      <div class="notification-icon" @click="toggleNotificationDropdown">
        <font-awesome-icon icon="bell" />
        <span v-if="totalNotifications > 0" class="notification-badge">{{ totalNotifications }}</span>
      </div>

      <!-- Notification Dropdown -->
      <div v-if="showNotificationDropdown" class="notification-dropdown">
        <div class="notification-header">
          <h3>Notifications</h3>
          <div class="notification-actions">
            <button @click="markAllAsRead" class="mark-all-read">Mark all as read</button>
          </div>
        </div>

        <div class="notification-tabs">
          <button 
            @click="activeTab = 'all'" 
            :class="{ 'active': activeTab === 'all' }"
            class="tab-button"
          >
            All
          </button>
          <button 
            @click="activeTab = 'tickets'" 
            :class="{ 'active': activeTab === 'tickets' }"
            class="tab-button"
          >
            Support Tickets <span v-if="getSupportTicketCount > 0" class="tab-count">{{ getSupportTicketCount }}</span>
          </button>
          <button 
            @click="activeTab = 'messages'" 
            :class="{ 'active': activeTab === 'messages' }"
            class="tab-button"
          >
            Messages <span v-if="notification.length > 0" class="tab-count">{{ notification.length }}</span>
          </button>
        </div>

        <div class="notification-list">
          <!-- Empty state -->
          <div v-if="activeNotifications.length === 0" class="empty-notification">
            <div class="empty-icon">🔔</div>
            <p>No notifications to display</p>
          </div>

          <!-- Ticket notifications -->
          <div 
            v-for="ticket in activeNotifications.filter(n => n.type === 'ticket')" 
            :key="'ticket-' + ticket.id"
            class="notification-item"
            :class="{ 'unread': !ticket.read }"
          >
            <div class="notification-content">
              <div class="notification-icon-container">
                <font-awesome-icon icon="ticket-alt" class="notification-type-icon" />
              </div>
              <div class="notification-details">
                <div class="notification-title">
                  Ticket #{{ ticket.id }}: {{ ticket.title }}
                </div>
                <div class="notification-info">
                  {{ ticket.client ? ticket.client : 'No Client' }} | {{ ticket.store ? ticket.store : 'No Store' }}
                </div>
                <div class="notification-time">
                  {{ $utils.displayDate(ticket.createdDate) }}
                </div>
              </div>
            </div>
            <div class="notification-actions">
              <button @click="viewTicket(ticket.id)" class="action-button view">View</button>
              <button @click="handleClaimTicket(ticket.id)" class="action-button claim">Claim</button>
            </div>
          </div>

          <!-- Message notifications -->
          <div 
            v-for="(message, index) in activeNotifications.filter(n => n.type === 'message')" 
            :key="'message-' + index"
            class="notification-item"
            :class="{ 'unread': !message.read }"
          >
            <div class="notification-content">
              <div class="notification-icon-container">
                <div class="sender-avatar">
                  {{ message.sentFrom ? message.sentFrom.charAt(0).toUpperCase() : 'U' }}
                </div>
              </div>
              <div class="notification-details">
                <div class="notification-title">
                  {{ message.sentFrom }}
                </div>
                <div class="notification-message">
                  {{ cleanHtml(message.note) }}
                </div>
                <div class="notification-time">
                  {{ formatTime(message.timeSent) }}
                </div>
              </div>
            </div>
            <div class="notification-actions">
              <a 
                @click="markRead(message.noteId)"
                :href="message.ticketUrl"
                class="action-button view"
                :target="message.internalLink ? '_self' : '_blank'"
              >
                View
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <audio ref="dingSound" src="@/assets/notification.mp3"></audio>
    <div class="user-settings my-2">

<!--      <custom-modal ref="notification" title="Pending Message" size="lg">-->
<!--        <ul class="list-unstyled">-->
<!--          <li v-for="message in notification" class="card mb-2">-->
<!--            <div class="card-header d-flex flex-row justify-content-between">-->
<!--              Sent From: {{message.sentFrom}}-->
<!--              <div class="d-flex justify-content-end">-->
<!--                <a class="btn btn-sm mx-3 btn-outline-info" :href="message.ticketUrl">View</a>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="card-body d-flex flex-column">-->
<!--              <span>Note: {{ message.note }}</span>-->
<!--              <span>Created : {{ $utils.displayDate(message.timeSent) }}</span>-->
<!--            </div>-->
<!--          </li>-->
<!--        </ul>-->
<!--      </custom-modal>-->

      <custom-modal ref="notification" title="Pending Notifications" size="lg">
        <div class="notifications-container">
          <div v-if="notification.length === 0" class="empty-state">
            <div class="empty-icon">📪</div>
            <p class="empty-text">No pending notifications</p>
          </div>

          <div v-else class="notifications-list">
            <div
                v-for="(message, index) in notification"
                :key="index"
                class="notification-item"
            >
              <!-- Header Section -->
              <div class="notification-header">
                <div class="sender-info">
                  <div class="sender-avatar">
                    {{ message.sentFrom ? message.sentFrom.charAt(0).toUpperCase() : 'U' }}
                  </div>
                  <div class="sender-details">
                    <div class="sender-name">{{ message.sentFrom }}</div>
                    <div class="notification-time">
                      <svg class="time-icon" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd" />
                      </svg>
                      {{ formatTime(message.timeSent) }}
                    </div>
                  </div>
                </div>

                <div class="notification-actions">
                  <a
                      @click="markRead(message.noteId)"
                      :href="message.ticketUrl"
                      class="view-ticket-btn"
                      target="_blank"
                      rel="noopener noreferrer"
                  >
                    <svg class="btn-icon" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                      <path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd" />
                    </svg>
                    View Ticket
                  </a>
                </div>
              </div>

              <!-- Content Section -->
              <div class="notification-content">
                <div class="notification-note" v-html="cleanHtml(message.note)"></div>

                <div class="notification-meta">
              <span class="meta-item">
                <svg class="meta-icon" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z" clip-rule="evenodd" />
                </svg>
                To: {{ message.sentTo }}
              </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </custom-modal>

      <div class="button-container" @click="viewUser">
      <button class="buttonn">
        <svg
            class="icon"
            stroke="currentColor"
            fill="black"
            stroke-width="0"
            viewBox="0 0 24 24"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M12 2.5a5.5 5.5 0 0 1 3.096 10.047 9.005 9.005 0 0 1 5.9 8.181.75.75 0 1 1-1.499.044 7.5 7.5 0 0 0-14.993 0 .75.75 0 0 1-1.5-.045 9.005 9.005 0 0 1 5.9-8.18A5.5 5.5 0 0 1 12 2.5ZM8 8a4 4 0 1 0 8 0 4 4 0 0 0-8 0Z"
          ></path>
        </svg>
      </button>

      <p class="username-text"> {{ curUser.Username }}</p>
      <font-awesome-icon icon="fa-circle-exclamation" class="flashing" v-if="showFine"/>
    </div>



      <!--      <button class="button">-->
<!--        <p>Fine pending</p>-->
<!--        <div class="active_line"></div>-->
<!--        <span class="text">You owe K4000</span>-->
<!--      </button>-->

      <button @click="findTicket" class="burger mx-3">
        <font-awesome-icon icon="magnifying-glass"/>
      </button>

      <button @click="syncData" class="burger">
        <font-awesome-icon icon="fa-solid fa-arrows-rotate"/>
      </button>

      <button @click="openCustomNotificationModal" class="burger mx-3">
        <font-awesome-icon icon="paper-plane"/>
      </button>
    </div>

    <custom-modal ref="ticketFinder" title="Ticket Finder" :is-form="true" @submit="checkTicket">
      <p class="text-primary text-sm">NB: Type a ticket number to quickly open it</p>

      <label for="checkTicketNumber" class="fw-bold">Ticket #</label>
      <input type="number" class="form-control" v-model="ticketNumber" id="checkTicketNumber" ref="tickNumber">
    </custom-modal>

    <custom-modal ref="customNotification" title="Send Custom Notification" :is-form="true" @submit="sendCustomNotification">
      <p class="text-primary text-sm">Send a custom notification to a user</p>

      <div class="mb-3">
        <label for="notificationReceiver" class="fw-bold">Receiver</label>
        <select class="form-control" v-model="customNotificationForm.receiverId" id="notificationReceiver" required>
          <option value="">Select a user</option>
          <option v-for="user in $store.getters.getAllUsers" :key="user.id" :value="user.id">{{ user.Username }}</option>
        </select>
      </div>

      <div class="mb-3">
        <label for="notificationMessage" class="fw-bold">Message</label>
        <textarea class="form-control" v-model="customNotificationForm.message" id="notificationMessage" rows="3" required></textarea>
      </div>

      <div class="mb-3">
        <label for="notificationLink" class="fw-bold">Link</label>
        <input type="text" class="form-control" v-model="customNotificationForm.link" id="notificationLink" required>
      </div>

      <div class="form-check mb-3">
        <input class="form-check-input" type="checkbox" v-model="customNotificationForm.internalLink" id="internalLinkCheck">
        <label class="form-check-label" for="internalLinkCheck">
          Open link in same tab
        </label>
      </div>
    </custom-modal>
  </div>
</template>
<script>
import CustomModal from "@/components/layout/CustomModal";
import Swal from "sweetalert2";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import {errorHandler} from "@/services/errorHandler";
import { sendNotification } from "@/utils/notifications";

export default {
  name: "NavigationBar",
  components: {CustomModal},
  data() {
    return {
      notification:[],
      checkObject: false,
      showFine: false,
      previousTicketCount: 0,
      ticketNumber: ``,
      onlineStatusInterval: null,
      ticketCountInterval: null,
      showNotificationDropdown: false,
      activeTab: 'all',
      customNotificationForm: {
        receiverId: '',
        message: '',
        link: '',
        internalLink: false
      }
    }
  },
  props: {
    toggle: {
      type: Function,
      require: true,
    },
  },
  computed: {
    ...mapGetters(["getEmployeeFine"]),
    ...mapGetters(["getSupportTicketCount"]),
    ...mapGetters(["getSupportTickets"]),
    // curUser() {
    //   return this.$store.getters.getCurrentUser;
    // },
    curUser() {
      let id = Number(this.$store.getters.getCurrentUser.id);
      return this.$store.getters.getAllUsers.find(user => user.id === id);
    },
    // Total number of notifications (tickets + messages)
    totalNotifications() {
      return this.getSupportTicketCount + this.notification.length;
    },
    // Formatted notifications for display
    formattedTickets() {
      return this.getSupportTickets.map(ticket => ({
        ...ticket,
        type: 'ticket',
        read: false // Assuming tickets are always unread until claimed
      }));
    },
    formattedMessages() {
      return this.notification.map(message => {
        // Check if this is a notification from the new endpoint
        if (message.message && message.link) {
          // Map the new format to the expected format
          return {
            id: message.id,
            noteId: message.id,
            sentFrom: message.senderId ? this.getUsernameById(message.senderId) : 'System',
            note: message.message,
            timeSent: message.createdAt,
            ticketUrl: message.link,
            internalLink: message.internalLink,
            type: 'message',
            read: message.read || false
          };
        } else {
          // Original format
          return {
            ...message,
            sentFrom: message.sentFrom || 'System',
            type: 'message',
            read: false // Assuming messages are always unread until clicked
          };
        }
      });
    },
    // Combined and filtered notifications based on active tab
    activeNotifications() {
      let notifications = [];

      if (this.activeTab === 'all' || this.activeTab === 'tickets') {
        notifications = notifications.concat(this.formattedTickets);
      }

      if (this.activeTab === 'all' || this.activeTab === 'messages') {
        notifications = notifications.concat(this.formattedMessages);
      }

      // Sort by date (newest first)
      return notifications.sort((a, b) => {
        const dateA = a.createdDate || a.timeSent;
        const dateB = b.createdDate || b.timeSent;
        return new Date(dateB) - new Date(dateA);
      });
    },
  },
  mounted() {
    // Connect to the WebSocket server
    // this.connectWebSocket();
  },
  methods: {
    // Toggle notification dropdown
    toggleNotificationDropdown() {
      this.showNotificationDropdown = !this.showNotificationDropdown;

      // Close dropdown when clicking outside
      if (this.showNotificationDropdown) {
        setTimeout(() => {
          document.addEventListener('click', this.closeNotificationDropdown);
        }, 0);
      }
    },

    // Close notification dropdown when clicking outside
    closeNotificationDropdown(event) {
      const dropdown = document.querySelector('.notification-dropdown');
      const icon = document.querySelector('.notification-icon');

      if (dropdown && !dropdown.contains(event.target) && !icon.contains(event.target)) {
        this.showNotificationDropdown = false;
        document.removeEventListener('click', this.closeNotificationDropdown);
      }
    },

    // Mark all notifications as read
    async markAllAsRead() {
      // Mark all message notifications as read
      const markPromises = this.notification.map(message => {
        return this.markRead(message.noteId);
      });

      await Promise.all(markPromises);

      // For ticket notifications, we don't have a direct way to mark them as read
      // They are considered read when claimed or viewed

      // Close the dropdown after marking all as read
      this.showNotificationDropdown = false;
    },

    async markRead(noteId){
      const payload = {
        noteId: noteId,
        userId: this.curUser.id
      }
      return await this.$store.dispatch("markAsRead",payload)
          .then(()=> this.fetchNotificationInfo())
    },

    getUsernameById(userId) {
      // Find the user in the users array
      const user = this.$store.getters.getAllUsers.find(user => user.id === userId);
      return user ? user.Username : 'Unknown User';
    },
    formatTime(timestamp) {
      const date = new Date(timestamp);
      const now = new Date();
      const diffMs = now - date;

      // Handle future dates
      if (diffMs < 0) {
        return date.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      }

      const diffInHours = diffMs / 36e5; // 36e5 is the number of milliseconds in an hour

      if (diffInHours < 1) {
        const minutes = Math.floor(diffInHours * 60);
        return `${minutes}m ago`;
      } else if (diffInHours < 24) {
        return `${Math.floor(diffInHours)}h ago`;
      } else {
        return date.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      }
    },
    cleanHtml(html) {
      // Remove HTML tags but preserve the text content
      if (!html) return ''; // Return empty string if html is undefined or null
      return html.replace(/<[^>]*>/g, '');
    },
    async fetchNotificationInfo(){
      try {
        const user = this.curUser;
        const response = await this.$store.dispatch("fetchNotificationInformation", user.id);
        this.notification = response || [];
        console.log('Fetched notifications:', response);
      } catch (error) {
        console.error('Error fetching notifications:', error);
        this.notification = [];
      }
    },
    viewUser() {
      this.$store.commit("setUserInfo", this.curUser);
      console.log(this.curUser)
      this.$router.push({
        name: "view-user",
        params: { id: this.curUser.id },
      });
    },
    async fetchFineData() {
      try {
        const response = await axios.get(synergy4 + `disciplinaryAction/getEmployeeFine/${this.curUser.id}`);
        this.rows = response.data;
        console.log(this.rows);
      } catch (error) {
        await errorHandler.tomcatError(error);
      }
    },
    showFines() {
      if (Array.isArray(this.rows)) {
        this.showFine = this.rows.some(fine => fine.isPaid === false);
      } else {
        this.showFine = false;
      }
    },
    goToFine() {
      this.$router.push({ name: "fine"});
    },
    ...mapActions(["fetchEmployeeFine"]),
    syncData() {
      window.location.reload(true);
    },
    async showTicketPopup() {
      if (this.getSupportTicketCount > 0) {
        await this.$store.dispatch(`getAllSupportTickets`);
        this.$refs.supportTickets.openModal();
      } else {
        Swal.fire({
          icon: 'info',
          title: 'No pending tickets available!',
          timer: 2000,
          showConfirmButton: false
        });
      }
    },
    async showMessagePopup() {
      this.$refs.notification.openModal();
    },

    ...mapActions(["connectWebSocket"]),
    // showTicketPopup() {
    //   if (this.getSupportTicketCount > 0) {
    //     this.$refs.supportTickets.openModal();
    //   } else {
    //     Swal.fire({
    //       icon: "info",
    //       title: "No pending tickets available!",
    //       timer: 2000,
    //       showConfirmButton: false,
    //     });
    //   }
    // },

    async handleClaimTicket(ticketId) {
      return this.claimTicket(ticketId).then(() => {
        return Swal.fire({
          icon: 'success',
          title: 'Claimed ticket successfully!',
          timer: 2000,
          showConfirmButton: false
        }).then(() => this.fetchAvailableTickets());
      });
    },
    viewTicket(ticketId) {
      if (this.$route.name === 'view-ticket') {
        return this.$router.replace({ name: 'view-ticket', params: { ticketId } })
            .then(()=>window.location.reload(true));
      }
      return this.$router.push({name: 'view-ticket', params: {ticketId}})
    },

    findTicket() {
      this.$refs.ticketFinder.openModal();
      setTimeout(() => {
        document.getElementById('checkTicketNumber').focus();
      }, 500);
    },
    checkTicket() {
      this.$utils.showLoading();
      return this.$store.dispatch(`checkTicket`, this.ticketNumber)
          .then(async (res) => {
            if (res) {
              this.viewTicket(this.ticketNumber)
              this.ticketNumber = ``
              return;
            }
            await responses.showWarning(`Ticket ${this.ticketNumber} not found`);
            return this.findTicket();
          }).finally(() => this.$utils.hideLoading());
    },
    updateUserOnlineStatus() {
      return this.$store.dispatch(`updateUserOnlineStatus`)
    },
    async fetchAvailableTickets() {
      this.$utils.showLoading();
      let currentCount = this.$store.getters.getSupportTicketCount;
      return this.$store.dispatch(`getAllSupportTickets`)
          .then(()=>{
            let newCount = this.$store.getters.getSupportTicketCount;
            if (currentCount < newCount) this.playDingSound();
          }).finally(()=>this.$utils.hideLoading());
    },
    async claimTicket(ticketNumber) {
      try {
        let user = this.$store.getters.getCurrentUser;
        const userID = user.id;
        await axios.put(ticketApiV2 + 'ticket/claimTicket', {
          userID,
          ticketNumber
        }).then(() => {
          this.fetchAvailableTickets();
          this.$store.dispatch(`getPreLoginData`)
        });
      } catch (error) {
        return errorHandler.tomcatError(error)
      }
    },

    playDingSound() {
      this.$refs.dingSound.play();
    },
    startOnlineStatusUpdate() {
      this.onlineStatusInterval = setInterval(async () => {
        await this.updateUserOnlineStatus();
      }, 60000 * 10); // 60000ms = 1 minute * 30 = 30 minute
    },
    startSupportUpdate() {
      this.ticketCountInterval = setInterval(async () => {
        await this.$store.dispatch(`countSupportTickets`);
        await this.fetchNotificationInfo();
      }, 30000); // 30000ms = 30 seconds
    },

    // Custom notification methods
    openCustomNotificationModal() {
      // Reset the form
      this.customNotificationForm = {
        receiverId: '',
        message: '',
        link: '',
        internalLink: false
      };

      // Open the modal
      this.$refs.customNotification.openModal();
    },

    async sendCustomNotification() {
      try {
        this.$utils.showLoading();

        const { receiverId, message, link, internalLink } = this.customNotificationForm;
        const currentUser = this.curUser;

        // Validate form
        if (!receiverId || !message || !link) {
          await Swal.fire({
            icon: 'error',
            title: 'Validation Error',
            text: 'Please fill in all required fields'
          });
          return;
        }

        // Send the notification
        await sendNotification(
          receiverId,
          message,
          link,
          currentUser.id,
          internalLink
        );

        // Show success message
        await Swal.fire({
          icon: 'success',
          title: 'Notification Sent',
          text: 'Your notification has been sent successfully'
        });

        // Close the modal
        this.$refs.customNotification.closeModal();

        // Refresh notifications
        await this.fetchNotificationInfo();
      } catch (error) {
        console.error('Error sending custom notification:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to send notification. Please try again.'
        });
      } finally {
        this.$utils.hideLoading();
      }
    },
  },
  watch:{
    getSupportTicketCount(newCount,currentCount){
      if (currentCount < newCount) this.playDingSound();
    },
    activeTab(newTab) {
      if (newTab === 'tickets') {
        this.fetchAvailableTickets();
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.onlineStatusInterval);
    clearInterval(this.ticketCountInterval);
  },
  async created() {
    await this.fetchFineData();
    this.showFines();
    await this.updateUserOnlineStatus();
    this.startOnlineStatusUpdate();
    this.startSupportUpdate();
    await this.fetchNotificationInfo();
  }
};
</script>
<style lang="scss" scoped>
/* YouTube-style Notification System */
.notification-container {
  position: relative;
  display: inline-block;
  margin-right: 15px;
}

.notification-icon {
  position: relative;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  svg {
    font-size: 1.25rem;
    color: white;
  }
}

.notification-badge {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #cc0000;
  color: white;
  border-radius: 50%;
  min-width: 18px;
  height: 18px;
  font-size: 11px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
}

.notification-dropdown {
  position: absolute;
  top: 45px;
  right: -100px;
  width: 480px;
  max-height: 600px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 90vw;
    right: -45vw;
  }
}

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #e5e5e5;

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
  }

  .notification-actions {
    .mark-all-read {
      background: none;
      border: none;
      color: #065fd4;
      font-size: 14px;
      cursor: pointer;
      padding: 8px;

      &:hover {
        background-color: rgba(0, 0, 0, 0.05);
        border-radius: 4px;
      }
    }
  }
}

.notification-tabs {
  display: flex;
  border-bottom: 1px solid #e5e5e5;

  .tab-button {
    flex: 1;
    background: none;
    border: none;
    padding: 12px 16px;
    font-size: 14px;
    cursor: pointer;
    position: relative;
    color: #606060;

    &.active {
      color: #0d0d0d;
      font-weight: 500;

      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 3px;
        background-color: #065fd4;
      }
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }

    .tab-count {
      background-color: #f2f2f2;
      border-radius: 10px;
      padding: 2px 6px;
      font-size: 12px;
      margin-left: 4px;
    }
  }
}

.notification-list {
  overflow-y: auto;
  max-height: 500px;
  padding: 8px 0;
}

.empty-notification {
  text-align: center;
  padding: 40px 16px;
  color: #606060;

  .empty-icon {
    font-size: 32px;
    margin-bottom: 16px;
  }

  p {
    margin: 0;
    font-size: 14px;
  }
}

.notification-item {
  padding: 12px 16px;
  border-bottom: 1px solid #f2f2f2;
  display: flex;
  flex-direction: column;
  gap: 8px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f9f9f9;
  }

  &.unread {
    background-color: #f0f7ff;

    &:hover {
      background-color: #e5f1ff;
    }
  }
}

.notification-content {
  display: flex;
  gap: 12px;
}

.notification-icon-container {
  flex-shrink: 0;

  .notification-type-icon {
    width: 40px;
    height: 40px;
    background-color: #f2f2f2;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #606060;
  }

  .sender-avatar {
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, #3b82f6, #1d4ed8);
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 16px;
  }
}

.notification-details {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;

  .notification-title {
    font-weight: 500;
    font-size: 14px;
    color: #0d0d0d;
  }

  .notification-info,
  .notification-message {
    font-size: 13px;
    color: #606060;
    line-height: 1.4;
  }

  .notification-time {
    font-size: 12px;
    color: #909090;
    margin-top: 4px;
  }
}

.notification-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;

  .action-button {
    background: none;
    border: 1px solid #d3d3d3;
    border-radius: 18px;
    padding: 6px 12px;
    font-size: 13px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: #f2f2f2;
    }

    &.view {
      color: #065fd4;
      border-color: #065fd4;

      &:hover {
        background-color: rgba(6, 95, 212, 0.05);
      }
    }

    &.claim {
      color: #065fd4;
      border-color: #065fd4;

      &:hover {
        background-color: rgba(6, 95, 212, 0.05);
      }
    }
  }
}

/* Original notification styles */
.notifications-container {
  max-height: 70vh;
  overflow-y: auto;
}

.empty-state {
  text-align: center;
  padding: 3rem 1rem;
  color: #6b7280;
}

.empty-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.empty-text {
  font-size: 1.1rem;
  margin: 0;
}

.notifications-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.notification-item {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.notification-item:hover {
  border-color: #d1d5db;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb;
}

.sender-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.sender-avatar {
  width: 2.5rem;
  height: 2.5rem;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.875rem;
}

.sender-details {
  display: flex;
  flex-direction: column;
}

.sender-name {
  font-weight: 600;
  color: #111827;
  font-size: 0.875rem;
}

.notification-time {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: #6b7280;
  font-size: 0.75rem;
}

.time-icon {
  width: 0.875rem;
  height: 0.875rem;
}

.notification-actions {
  display: flex;
  gap: 0.5rem;
}

.view-ticket-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: #3b82f6;
  color: white;
  text-decoration: none;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.view-ticket-btn:hover {
  background: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
  color: white;
  text-decoration: none;
}

.btn-icon {
  width: 1rem;
  height: 1rem;
}

.notification-content {
  padding: 1.25rem;
}

.notification-note {
  color: #374151;
  line-height: 1.6;
  margin-bottom: 1rem;
  font-size: 0.875rem;
}

.notification-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding-top: 0.75rem;
  border-top: 1px solid #f3f4f6;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  color: #6b7280;
  font-size: 0.75rem;
}

.meta-icon {
  width: 0.875rem;
  height: 0.875rem;
}

/* Custom scrollbar for notifications container */
.notifications-container::-webkit-scrollbar {
  width: 6px;
}

.notifications-container::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.notifications-container::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.notifications-container::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Responsive design */
@media (max-width: 768px) {
  .notification-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 1rem;
  }

  .notification-actions {
    align-self: stretch;
  }

  .view-ticket-btn {
    width: 100%;
    justify-content: center;
  }

  .sender-info {
    width: 100%;
  }

  .notification-content {
    padding: 1rem;
  }

  .notification-meta {
    flex-direction: column;
    gap: 0.5rem;
  }
}

@media (max-width: 480px) {
  .notifications-container {
    max-height: 60vh;
  }

  .sender-avatar {
    width: 2rem;
    height: 2rem;
    font-size: 0.75rem;
  }

  .notification-header {
    padding: 0.75rem;
  }

  .notification-content {
    padding: 0.75rem;
  }

  .container-fluid.navigation-bar {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }

  .navigation-box {
    display: inline-flex;
    margin-right: 5px;
  }

  .user-settings {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
    margin-left: auto;
  }

  .button-container {
    display: flex;
    width: auto;
    min-width: 120px;
    height: 40px;
    margin: 5px;
    padding: 0 5px;
  }

  /* Make bell smaller and more elegant on mobile */
  .burger {
    width: 35px;
    height: 35px;
    font-size: 22px;
    transition: all 0.2s ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .burger:active {
    transform: scale(0.95);
  }

  .notification-badge {
    font-size: 10px;
    padding: 1px 4px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  }

  /* Adjust username text for mobile */
  .username-text {
    max-width: 70px;
    font-size: 0.9rem;
  }
}
.container-fluid.navigation-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
}

.navigation-box {
  display: inline-flex;
  align-items: center;
  margin-right: 5px;
}

.burger {
  width: 40px;
  height: 40px;
  background: transparent;
  color: white;
  font-size: 30px;
}

.user-settings {
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  flex-wrap: nowrap;
  margin-left: auto;
}

button.btn {
  margin: 5px;
}

.red-blinking {
  color: red;
  animation: blinker 1.5s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.notification-badge {
  position: fixed;
  margin-right: 5px;
  color: white;
  border-radius: 5px;
  padding: 1px 6px 1px 6px;
  font-size: 12px;
  opacity: 0; /* Initially hidden */
  transform: scale(0); /* Initially small size */
  transition: opacity 0.3s ease, transform 0.3s ease;
}

/* Desktop behavior - always show notification badges */
@media (min-width: 769px) {
  .burger .notification-badge {
    opacity: 1;
    transform: scale(1);
    animation: notification-pulse 1.5s infinite;
  }
}

/* Mobile behavior - only show on hover/active */
@media (max-width: 768px) {
  .burger .notification-badge {
    opacity: 0;
    transform: scale(0);
  }

  .burger:hover .notification-badge,
  .burger:active .notification-badge,
  .burger:focus .notification-badge {
    opacity: 1;
    transform: scale(1);
    animation: notification-pulse 1.5s infinite;
  }
}

@keyframes notification-pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 yellow;
  }
  50% {
    transform: scale(1.2);
    box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 yellow;
  }
}

//@import "src/assets/style/hide-table-mobile";
.text-sm {
  font-size: 12px;
}

@keyframes blinkingRed {
  0%, 100% { background-color: red; color: white; }
  50% { background-color: white; color: black; border: 2px solid black; }
}
.button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 40px;
  border: 2px solid red;
  cursor: pointer;
  border-radius: 0.4em;
  background: red;
  color: white;
  font-weight: bold;
  animation: blinkingRed 2s infinite;
}

.active_line {
  content: "";
  position: absolute;
  bottom: 0;
  width: 0.9em;
  height: 0.4em;
  background-color: #999;
  border: none;
  border-radius: 1em;
  transition: all 0.15s linear;
}

.button:active .active_line,
.button:focus .active_line {
  width: 2.3em;
  background-color: rgb(41, 126, 255);
}


@keyframes wow {
  20% {
    scale: 0.8;
  }

  30% {
    scale: 1;
    transform: translateY(0);
  }

  50% {
    transform: translateY(-6px);
  }

  65% {
    transform: translateY(4px);
  }

  80% {
    transform: translateY(0);
  }

  100% {
    scale: 1;
  }
}

.text {
  z-index: 1000;
  content: "";
  position: absolute;
  top: 4.5em;
  width: fit-content;
  height: 2.6em;
  background-color: #666;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 5px;
  text-shadow: 0 0 10px rgb(0, 0, 0);
  opacity: 0;
  transition: all 0.25s linear;
}

.button:hover .text {
  opacity: 1;
}

@keyframes flash {
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}

.flashing-image {
  width: 30px;
  height: 30px;
  animation: flash 1s infinite; /* Flashes every 1 second */
}
.flashing {
  animation: flash 1s infinite;
}
.fine-div {
  width: 90px;
  padding: 5px;
  display: flex;

  border-radius: 10px;
  background-color: yellow;
  justify-content: space-between;
  align-items: center;
  position: relative;
  cursor: pointer;
}
.tooltip-text {
  visibility: hidden;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 10px;
  border-radius: 5px;
  position: absolute;
  bottom: 150%;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.3s;
}

.fine-div:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

.button-container {
  display: flex;
  background-color: aliceblue;
  min-width: 120px;
  max-width: 150px;
  width: auto;
  height: 40px;
  margin-left: 8px;
  align-items: center;
  justify-content: space-around;
  border-radius: 10px;
  cursor: pointer;
  flex-shrink: 0;
  overflow: hidden;
}

.username-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80px;
  margin: 0;
  padding: 0 2px;
}
.button-container:hover {
  background-color: lightgray;
}

.buttonn {
  outline: 0 !important;
  border: 0 !important;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transition: all ease-in-out 0.3s;
  cursor: pointer;
}

.buttonn:hover {
  transform: translateY(-3px);
}

.icon {
  font-size: 20px;
}

@keyframes subtle-blink {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

.icon-blink {
  animation: subtle-blink 2s ease-in-out infinite;
}

</style>
